import styled from 'styled-components';

export const ListBox = styled.div`
  > * + * {
    margin-top: 8px;
  }
`;
